function initStickyHeader() {
  const siteHeader = document.querySelector(".site-header");
  const headerContainer = document.querySelector(".header-container");

  if (!siteHeader || !headerContainer) {
    return;
  }

  // The point at which the header becomes sticky.
  // We'll use the header's initial top offset plus its height.
  const stickyThreshold = siteHeader.offsetTop + headerContainer.offsetHeight;

  let lastScrollY = window.scrollY;
  let ticking = false;

  const handleScroll = () => {
    lastScrollY = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (lastScrollY > stickyThreshold) {
          siteHeader.classList.add("is-sticky");
          document.body.classList.add("header-is-sticky");
        } else {
          siteHeader.classList.remove("is-sticky");
          document.body.classList.remove("header-is-sticky");
        }
        ticking = false;
      });

      ticking = true;
    }
  };

  // Attach the event listener
  window.addEventListener("scroll", handleScroll, { passive: true });

  // Initial check in case the page is already scrolled down on load
  handleScroll();
}

// Run on page load
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initStickyHeader);
} else {
  initStickyHeader();
}
